export const formatNumber = (value: number, language: string) => new Intl.NumberFormat(language).format(value);
